(function () {
  const requireInputs = document.querySelectorAll(".participation__form-input.required");
  const requireCheckboxes = document.querySelectorAll('.participation__form-checkbox.required');
  const submitButton = document.querySelector('.participation__form-submit');
  const inputs = document.querySelectorAll('.participation__form-input');
  const checkboxes = document.querySelectorAll('.participation__form-input--no-text');
  const pdfConfirmBtn = document.querySelector('.participation__step3-confirm-btn--pdf');
  const backToTopBtn = document.querySelector('.participation__step3-link');
  const resultText = document.querySelectorAll('.participation__results-text');
  const submitFormData = document.querySelector('.participation__results-forward');

  const phonePatern = /^[0-9]+$/;
  const emailPatern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  const kanaPatern = /^[ァ-ンｧ-ﾝﾞﾟー]+$/;
  const arrayInputs = Array.from(requireInputs).concat(Array.from(requireCheckboxes))
  const allInputs = Array.from(inputs).concat(Array.from(checkboxes));
  const url = document.location.href;
  const resultTextId = Array.from(resultText).filter(item => item.hasAttribute('id'));
  const stgUrl = 'https://stg-aifood.eyelabs2.com/api/inquiries';
  const prdUrl = 'https://www.aifood.jp/api/inquiries';

  function addError (elem ,text) {
    const errorMessage = elem.closest('.participation__form-row').nextElementSibling;
    elem.classList.remove("has-success");
    elem.classList.add("has-error");
    errorMessage.style.display = 'inline';
    errorMessage.textContent = text;
  }

  function removeError(elem){
    const errorMessage = elem.closest('.participation__form-row').nextElementSibling;
    elem.classList.remove("has-error");
    elem.classList.add('has-success');
    errorMessage.textContent = '';
    errorMessage.style.display = "none";
  }

  function regexpValidation (elem, regexp, text) {
    let patern = new RegExp(regexp)
    if (!patern.test(elem.value) && elem.value !== "") {
      addError(elem, text);
    }else if (elem.value === '') {
      addError(elem, "この項目は必須です。")
    }
    else{
      removeError(elem)
    }
  }
  

  function validate (elem) {
    if (elem.classList.contains('participation__form-input--phone')) {
      regexpValidation(elem, phonePatern, '半角英数字で入力してください。')
    }else if(elem.classList.contains('participation__form-input--email')){
      regexpValidation(elem, emailPatern, '半角英数字で入力してください。')
    }else if (elem.classList.contains('participation__form-input--kana')){
      regexpValidation(elem, kanaPatern, 'この項目はカタカナで入力してください。')
    }
    else if (elem.value === "") {
      addError(elem, "この項目は必須です。")
    }
    else{
      removeError(elem);
    }
  };

  function everyInputsSuccess (input) {
    return input.classList.contains('has-success');
  }
  function changeAjaxUrl () {
    if (url.search('eyelabs2') >= 1 || url.search('localhost') >= 1){
      return stgUrl;
    }
    else{
      return prdUrl;
    }
  }

  function inputChecked (input) {
    if (input.checked){
      input.classList.add('has-success')
    }else{
      input.classList.remove('has-success')
    }
  }

  arrayInputs.forEach(item => {
    item.addEventListener('change', function(){
      if (item.classList.contains('participation__form-input')){
        validate(item);
      }else{
        inputChecked(item);
      }
      if (arrayInputs.every(everyInputsSuccess)) {
        submitButton.classList.remove('disabled')
      }else{
        submitButton.classList.add('disabled')
      }
    })
  })
  
  try{
    submitButton.addEventListener('click', function (e) {
      let actionArray = [];
      if (this.classList.contains('disabled')){
        e.preventDefault();
      }
      localStorage.clear();
      allInputs.forEach(item => {
        if (item.getAttribute('name') === 'contact_action'){
          if (item.checked){
            actionArray.push(item.value);
            localStorage.setItem('contact_action', actionArray);
          }
        }else{
          localStorage.setItem(item.getAttribute('name'), item.value);
        }
      })
    })
  }catch{}

  document.addEventListener("DOMContentLoaded", function () {
    if (url.search('step_1') >= 1){
      if (localStorage.length !== 0){        
        inputs.forEach(item => {
          let name = item.getAttribute("name");
          for(let key in localStorage){
            if (key === name) {
              item.value = localStorage[key];
            }
            if (item.classList.contains('required')) {
              item.classList.add('has-success')
            }
          }
        });
      
        checkboxes.forEach(item => {
          let name = item.getAttribute("name");
          for(let key in localStorage){
            if (name === 'contact_action' && key === name){
              const contactActionValue = localStorage['contact_action'].split(',');
              contactActionValue.forEach(value => {
                if (value === item.value){
                  item.checked = true;
                }
              })
            }
            if (name !== 'contact_action' && key === name){
              item.checked = true;
            }
          }
          if (item.classList.contains('required')) {
            item.classList.add('has-success')
          }
        })
      }
    }

    try{
      if (arrayInputs.every(everyInputsSuccess)) {
        submitButton.classList.remove('disabled')
      }else{
        submitButton.classList.add('disabled')
      }
    }catch{}
  
    if (url.search('step_2') >= 1){
      resultTextId.forEach(item => {
        let id = item.getAttribute("id");
        for(let key in localStorage){
          if (key === id && id === 'contact_action'){
            const contactActionValue = localStorage['contact_action'].split(',');
            contactActionValue.forEach(action => {
              const listItem = document.createElement('li');
              listItem.textContent = action;
              item.append(listItem);
            })
          }else if (key === id) {
            item.textContent = localStorage[key];
          } 
        }
      })
      submitFormData.addEventListener('click', function(e) {
        e.preventDefault()
        let formData = {}
        for (let key in localStorage){
          if (typeof localStorage[key] !== 'function') {
            if (key === 'contact_action') {
              const contactActionArray = localStorage[key].split(',')
              formData[key] = contactActionArray;
            }else{
              formData[key] = localStorage[key]
            }
          }
        }
        submitFormData.setAttribute('disabled', true)
        $.ajax({
          type: "POST",
          url: changeAjaxUrl(),
          data: formData,
          success: () => {
            document.location.href = '/participation/step_3.html';
          },
          error: () => {
            submitFormData.removeAttribute('disabled');
          }
        });
      })
    }

    if (localStorage.length === 0) {
      try{
        pdfConfirmBtn.classList.add('disabled');
        pdfConfirmBtn.addEventListener('click', function (e){
          e.preventDefault();
        })
        backToTopBtn.classList.add('active');
      }catch{}
    }
    try{
      pdfConfirmBtn.addEventListener('click', function () {
        backToTopBtn.classList.add('active');
      })
      $(backToTopBtn).on('click', function (e) {
        if ($(this).hasClass('active')){
          $(this).unbind('click').click();
        }else{
          e.preventDefault();
        }
      })
    }catch{}

  });

})();